import React, { useRef, useEffect, useState, useMemo } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import northPolygonData from './Geojsons/northPolygonData.geojson';
import centralAPolygonData from './Geojsons/centralAPolygonData.geojson';
import centralBPolygonData from './Geojsons/centralBPolygonData.geojson';
import kashmirPolygonData from './Geojsons/kashmirPolygonData.geojson';
import southPolygonData from './Geojsons/southPolygonData.geojson';
import test_cities from './Geojsons/test_cities.json';
import all_cities from './Geojsons/city_data.json';
import { getImageUrl } from '../GetImage/GetImage';
import { styled } from '@mui/material/styles';
import { Box, Skeleton, Typography, TextField } from '@mui/material';
import Slider from '@mui/material/Slider';
import PauseRounded from '@mui/icons-material/PauseRounded';
import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded';
import FastForwardRounded from '@mui/icons-material/FastForwardRounded';
import FastRewindRounded from '@mui/icons-material/FastRewindRounded';
import IconButton from '@mui/material/IconButton';
import { RefreshButton } from '../../common/components/refresh_button.component';
import { useNavigate } from 'react-router-dom';
import TableChartIcon from '@mui/icons-material/TableChart';
import MapIcon from '@mui/icons-material/Map';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import TuneIcon from '@mui/icons-material/Tune';
import Tooltip from '@mui/material/Tooltip';
import * as THREE from 'three';
import { logout } from '../../common/functions/log_out.function';
import { isNewOtnImplementation } from '../../common/functions/otn_new_implementation.function';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { Cities } from '../../enums/cities.enum';
import { findCityByAlias } from '../../common/functions/find_City_By_Alias.function';
import { findRegionByAlias } from '../../common/functions/find_Region_By_Alias.function';
import pakistanPolygonData from './Geojsons/pakistanPolygonData.geojson';
import completePakistanPolygonData from '../../Components/Map/Geojsons/completePakistanPolygonData.geojson';
import './mapStyles.css';
import apiClient from '../../common/functions/api_axios_instance.function';
import { removeOldBoundaryLayers } from '../../common/functions/remove_boundry_layers.function';
import { handleApiError } from '../../common/functions/errorHandler.function';
import { geoServerSites } from '../../common/functions/get_geoServer_sites.function';
import { geoServerLinks } from '../../common/functions/get_geoServer_links.function';

import * as turf from '@turf/turf';
mapboxgl.accessToken = process.env.REACT_APP_PUBLIC_MAP_BOX_GL_ACCESS_TOKEN;
const TinyText = styled(Typography)({
  fontSize: '0.75rem',
  fontWeight: 500,
  letterSpacing: 0.2,
  color: '#FFF',
});

const Widget = styled('div')(({ theme }) => ({
  padding: 10,
  borderRadius: 16,
  maxWidth: '100%',
  position: 'relative',
  zIndex: 1,
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.6)' : '#192126',
}));

export default function IpranMap({
  setViewType,
  data,
  videoPlayTime,
  setVideoPlayTimeFromStart,
  setVideoPlayTimeEnd,
  handleReset,
  regionData,
  loading,
  markerRef,
  selectedAlarm,
  link,
  site,
  viewType,
  city,
  region,
  ring,
  setVideoPlayTime,
  alramType,
  setAlramType,
  open,
  toggleDrawer,
  applyFilters,
  state,
  selectedDate,
  setSelectedDate,
}) {
  const prevAlarmData = useRef([]);
  const tab = sessionStorage.getItem('selectedTab');
  let currentPopup = null;
  let popupTimer = null;
  const color = 'red';
  const currentPopupRef = useRef(null);
  const controllerRef = useRef(null);
  const requestManagerRef = useRef(new Map()); // Track all active requests
  const alarmsData = data;
  const mapContainer = useRef(null);
  const map = useRef(null);
  const today = dayjs();
  const stepRef = useRef(0);
  const [lng, setLng] = useState(69.3451);
  const [lat, setLat] = useState(30.3753);
  const [zoom, setZoom] = useState(5);
  const [sitePopupFlag, setSitePopupFlag] = useState(false);
  const [linkPopupFlag, setLinkPopupFlag] = useState(false);
  const [popupFlag, setPopupFlag] = useState(false);
  const sitePopupRef = useRef(null);
  const cityMarkers = useRef([]);
  const regionMarkers = useRef([]);
  const alarmMarker = useRef([]);
  const duration = 86400; // seconds
  const [position, setPosition] = useState(0);
  const [paused, setPaused] = useState(true);
  const [intervalID, setIntervalID] = useState();
  const [playerHover, setPlayerHover] = useState(false);
  const mainIconColor = '#000';
  const [isLoading, setIsLoading] = useState(true);
  // #afcef9
  // #e39b88
  // #E9F3B6
  // #ffd886

  // Add state for 3D marker management
  const [threeDMarkersVisible, setThreeDMarkersVisible] = useState(false);
  const threeDMarkersRef = useRef([]);
  const ZOOM_THRESHOLD_FOR_3D = 7; // Show 3D markers when zoom >= 10

  // Add state for city marker management
  const [cityMarkersVisible, setCityMarkersVisible] = useState(false);
  const CITY_MARKERS_ZOOM_MIN = 9; // Show city markers when zoom >= 9
  const CITY_MARKERS_ZOOM_MAX = 11; // Hide city markers when zoom > 11
  const [regions, setRegions] = useState([
    {
      id: 'north-polygon',
      regionName: 'North',
      alarmsCount: 0,
      data: northPolygonData,
      color: '#c5d5ef',
      center: [72.94996378341335, 34.974994348955335],
    },
    {
      id: 'centralA-polygon',
      regionName: 'Central A',
      alarmsCount: 0,
      data: centralAPolygonData,
      color: '#f1bdb6',
      center: [73.40944846601698, 30.590024194213726],
    },
    {
      id: 'centralB-polygon',
      regionName: 'Central B',
      alarmsCount: 0,
      data: centralBPolygonData,
      color: '#c4d8a5',
      center: [71.16216343821162, 30.486783539931153],
    },
    {
      id: 'south-polygon',
      regionName: 'South',
      alarmsCount: 0,
      data: southPolygonData,
      color: '#f8e1b9',
      center: [66.5, 27.486783539931153],
    },
    {
      id: 'kashmir-polygon',
      regionName: 'Kashmir',
      alarmsCount: 0,
      data: kashmirPolygonData,
      color: '#f2c3fa',
      center: [73.781, 33.9259],
    },
    {
      id: 'pakistan',
      regionName: 'Pakistan',
      alarmsCount: 0,
      data: completePakistanPolygonData,
      color: '#5f8282',
      center: [72.94996378341335, 34.974994348955335],
    },
  ]);
  const [regionsMpbn, setRegionsMpbn] = useState([
    {
      id: 'north-polygon',
      regionName: 'North',
      alarmsCount: 0,
      color: '#35527e',
      center: [72.94996378341335, 34.974994348955335],
    },
    {
      id: 'centralA-polygon',
      regionName: 'Central-1',
      alarmsCount: 0,
      color: '#893e2a',
      center: [73.40944846601698, 30.590024194213726],
    },
    {
      id: 'centralB-polygon',
      regionName: 'Central-2',
      alarmsCount: 0,
      color: '#66773c',
      center: [71.16216343821162, 30.486783539931153],
    },
    {
      id: 'south-polygon',
      regionName: 'South',
      alarmsCount: 0,
      color: '#906b23',
      center: [66.5, 27.486783539931153],
    },
    {
      id: 'pakistan',
      regionName: 'Pakistan',
      alarmsCount: 0,
      data: pakistanPolygonData,
      color: '#446363',
      center: [72.94996378341335, 34.974994348955335],
    },
    {
      id: 'kashmir-polygon',
      regionName: 'Kashmir',
      alarmsCount: 0,
      data: kashmirPolygonData,
      color: '#446363',
      center: [73.781, 33.9259],
    },
  ]);
  const [cities, setCities] = useState(test_cities);

  // Local state for the Map's DatePicker
  const defaultDate = dayjs();
  const [mapSelectedDate, setMapSelectedDate] = useState(defaultDate);

  const handleDateChange = (newDate) => {
    setMapSelectedDate(newDate);
    // Also update the parent's selectedDate
    setSelectedDate(newDate);
  };
  useEffect(() => {
    if (map.current) {
      map.current.resize();
    } // delay to allow DOM transition to complete
  }, [open]);
  // Utility function to cancel all active requests
  const cancelAllRequests = () => {
    console.log('[Map] Cancelling all active requests...');

    if (requestManagerRef.current) {
      const requestCount = requestManagerRef.current.size;
      console.log(`[Map] Found ${requestCount} active requests to cancel`);

      requestManagerRef.current.forEach((controller, requestId) => {
        if (controller && !controller.signal.aborted) {
          console.log(`[Map] Cancelling request: ${requestId}`);
          controller.abort();
        }
      });
      requestManagerRef.current.clear();
    }

    if (controllerRef.current && !controllerRef.current.signal.aborted) {
      console.log('[Map] Cancelling main controller');
      controllerRef.current.abort();
    }

    console.log('[Map] All requests cancelled');
  };

  // Utility function to add a request to the manager
  const addRequestToManager = (requestId, controller) => {
    if (requestManagerRef.current) {
      requestManagerRef.current.set(requestId, controller);
      console.log(`[Map] Added request to manager: ${requestId}`);
    }
  };

  // Utility function to remove a request from the manager
  const removeRequestFromManager = (requestId) => {
    if (requestManagerRef.current) {
      requestManagerRef.current.delete(requestId);
      console.log(`[Map] Removed request from manager: ${requestId}`);
    }
  };

  const clearAll = () => {
    if (currentPopup) {
      currentPopup.remove();
      currentPopup = null;
    }

    // Cancel all active requests
    cancelAllRequests();

    // Force cleanup of all event listeners
    if (map?.current) {
      map.current.off('mouseenter', 'linksLayers');
      map.current.off('mouseleave', 'linksLayers');
      map.current.off('click', 'linksLayers');
      map.current.off('mouseenter', 'linksLayerss');
      map.current.off('mouseleave', 'linksLayerss');
      map.current.off('click', 'linksLayerss');
    }

    // Force cleanup of all layers
    removeWmsLayer();
    removeWmsLayerMpbn();

    setLng(69.3451);
    setLat(30.3753);
    handleRefresh();
    handleReset();
    if (markerRef?.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
    removeAlarmsMarker();
    removeCurrentPopup();
    removeSitePopup();
    // Clear 3D markers
    hideThreeDMarkers();
    // Clear city markers
    hideCityMarkers();
  };
  useEffect(() => {
    clearAll();
  }, [tab]);

  useEffect(() => {
    const isCurrentDate = mapSelectedDate.isSame(dayjs(), 'day');
    if (isCurrentDate && alramType === 'live') {
      // For live alarms on current date, use 24 hours ago to current time
      const now = dayjs();
      const twentyFourHoursAgo = now.subtract(24, 'hour');
      setVideoPlayTimeFromStart(
        `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
      );
      setVideoPlayTime(
        `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
      );
      setVideoPlayTimeEnd(`${now.format('YYYY-MM-DD')} ${now.format('HH:mm:ss')}`);
    } else {
      // For history alarms or past dates, use the selected date
      const startTime = `${mapSelectedDate.format('YYYY-MM-DD')} 00:00:00`;
      const endTime = `${mapSelectedDate.format('YYYY-MM-DD')} 23:59:59`;

      console.log('Map component setting video play times:', {
        startTime,
        endTime,
        selectedDate: mapSelectedDate.format('YYYY-MM-DD'),
        alramType,
      });

      setVideoPlayTime(startTime);
      setVideoPlayTimeFromStart(startTime);
      setVideoPlayTimeEnd(endTime);
    }
    setPosition(0);
  }, [mapSelectedDate, alramType]);
  useEffect(() => {
    if (data) {
      setIsLoading(true);

      if (tab === 'otn' || tab === 'ipran' || tab === 'ftts') {
        const updatedDataArr = regions.map((region) => {
          let alarmsCount = 0;
          if (tab === 'ipran') {
            // For IPRAN, check both source_region and region fields
            alarmsCount = data?.filter(
              (alarm) => (alarm.source_region || alarm.region) === region.regionName
            ).length;
          } else {
            alarmsCount = data?.filter((alarm) => alarm.region === region.regionName).length;
          }
          return { ...region, alarmsCount };
        });
        setRegions(updatedDataArr);
      }
      if (tab === 'mpbn') {
        const updatedDataArr = regionsMpbn.map((region) => {
          const alarmsCount = data?.filter((alarm) => alarm.region === region.regionName).length;
          return { ...region, alarmsCount };
        });
        setRegionsMpbn(updatedDataArr);
      }

      const updatedCitiesDataArr = cities.map((city) => {
        const alarmsCount = data?.filter(
          (alarm) => alarm?.city?.toUpperCase() === city?.name?.toUpperCase()
        ).length;
        return { ...city, alarmsCount };
      });
      setCities(updatedCitiesDataArr);
      if (map.current) {
        if (zoom < 8) {
          showRegionMarkers();
        }
      }

      setIsLoading(false);
    }
  }, [data, map.current, zoom, tab]);

  useEffect(() => {
    if (selectedAlarm?.lat && selectedAlarm?.long) {
      setLng(selectedAlarm.long);
      setLat(selectedAlarm.lat);

      if (map.current) {
        addAlarmMarker([selectedAlarm.long, selectedAlarm.lat]);

        map.current.flyTo({
          center: [selectedAlarm.long, selectedAlarm.lat],
          zoom: 14, ///link zoom from left tab
          essential: true,
          duration: 1300,
        });
      }
    }
  }, [selectedAlarm]);

  const handleRefresh = () => {
    if (region || city || ring || link || site) {
      handleReset();
    }
    hideCityMarkers();
    map?.current?.flyTo({
      center: [69.3451, 30.3753],
      zoom: 5,
      bearing: 0,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response, foundObj, lng, lat, zoomTo;
        if (ring || link || site) {
          if (applyFilters) {
            const endpointMap = {
              otn: {
                url: isNewOtnImplementation() ? '/snmpOTN/ringCenter' : '/otn/ringCenter',
                params: { region, city, linkName: link, site },
              },
              ftts: {
                url: '/ftts/ringCenter',
                params: { region, city, linkName: link, site },
              },
              mpbn: {
                url: '/mpbn/ringCenter',
                params: { city, ring, linkName: link, site },
              },
              ipran: {
                url: '/ipran/ringCenter',
                params: { region, city, ring, linkName: link, site },
              },
            };

            const { url, params } = endpointMap[tab] || {};
            if (!url) {
              console.warn(`Unsupported tab: ${tab}`);
              return;
            }

            response = await apiClient.get(url, { params });

            if (response?.data[0] || response?.data?.response[0]) {
              foundObj =
                tab === 'mpbn' || tab === 'ftts' ? response?.data[0] : response?.data?.response[0];

              lng = foundObj?.[0];
              lat = foundObj?.[1];
              zoomTo = 13; // Higher zoom level for site

              // Ensure zoom level is appropriate
              zoomTo = Math.min(Math.max(zoomTo, 13), 19); // Adjust as needed

              setLng(lat);
              setLat(lng);

              // Remove the previous marker if it exists
              if (markerRef.current) {
                markerRef.current.remove();
              }
              markerRef.current = new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map.current);
              // Use easeTo for faster zoom
              map.current.flyTo({
                center: [lat, lng],
                zoom: zoomTo,
                duration: 1200, // Adjust duration for smoother transition
              });
            } else {
              foundObj = findCityByAlias(all_cities, city);
              lng = foundObj?.lng;
              lat = foundObj?.lat;
              zoomTo = 12; // Default zoom level for cities
            }
          }
        } else if (city) {
          foundObj = findCityByAlias(all_cities, city);
          lng = foundObj?.lng;
          lat = foundObj?.lat;
          zoomTo = 12; // Default zoom level for cities
        } else if (region) {
          foundObj = findRegionByAlias(regions, region);
          lng = foundObj?.center[0];
          lat = foundObj?.center[1];
          zoomTo = 11; // Default zoom level for regions
        } else {
          lng = 69.3451;
          lat = 30.3753;
          zoomTo = 5; // Default zoom level for the whole map
        }

        if (lng !== undefined && lat !== undefined) {
          setLng(lng);
          setLat(lat);

          // Use easeTo for faster zoom
          map.current.flyTo({
            center: [lng, lat],
            zoom: zoomTo,
            duration: 2000, // Adjust duration for smoother transition
          });
        } else {
          console.error('No data found');
        }
      } catch (error) {
        handleApiError(error);

        const fallbackCity = findCityByAlias(all_cities, city);
        if (fallbackCity) {
          const lng = fallbackCity?.lng;
          const lat = fallbackCity?.lat;
          const zoomTo = 12; // Default zoom level for fallback

          setLng(lng);
          setLat(lat);

          // Use easeTo for faster zoom
          map.current.flyTo({
            center: [lng, lat],
            zoom: zoomTo,
            duration: 2000, // Adjust duration for smoother transition
          });
        }
      }
    };
    if (map.current) {
      console.log('here', applyFilters);

      fetchData();
    }
    return () => {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = null;
      }
    };
  }, [city, region, site, link, map, all_cities]);
  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.remove();
    }
  }, [tab]);
  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
    // const [lng, setLng] = useState(69.3451);
    // const [lat, setLat] = useState(30.3753);
    if (isLoading === false) {
      if (!map.current) {
        map.current = new mapboxgl.Map({
          container: mapContainer.current,
          style: 'mapbox://styles/mapbox/standard',
          center: [lng, lat],
          zoom: zoom,
          attributionControl: false,
          pitch: 0,
        });
        map.current.addControl(
          new mapboxgl.NavigationControl({ showCompass: false }),
          'bottom-right'
        );

        map.current.on('load', () => {
          if (controllerRef.current) {
            controllerRef.current.abort();
          }
          controllerRef.current = new AbortController();
          updateLayers(); // Function to update layers

          // Add zoom event listener for 3D marker management
          map.current.on('zoom', handleZoomChange);
          console.log('Zoom event listener attached to map');

          // Add general map click handler to prevent unwanted zoom changes at high zoom levels
          map.current.on('click', (e) => {
            const currentZoom = map.current.getZoom();
            if (currentZoom >= 12) {
              // At high zoom levels, prevent automatic zoom changes
              // Only allow clicks on specific elements (popups, markers, etc.)
              const clickedElement = e.originalEvent.target;
              const isAllowedElement =
                clickedElement.closest('.mapboxgl-popup-content') ||
                clickedElement.closest('.region-marker') ||
                clickedElement.closest('.custom-marker') ||
                clickedElement.closest('.mapboxgl-marker') ||
                clickedElement.closest('.mapboxgl-popup-close-button');

              if (!isAllowedElement) {
                console.log('Preventing map click at high zoom level:', currentZoom);
                e.preventDefault();
                return;
              }
            }
          });

          // Check initial zoom level for 3D markers
          console.log('Initial zoom check - zoom level:', map.current.getZoom());
          if (map.current.getZoom() >= ZOOM_THRESHOLD_FOR_3D && map.current.getZoom() < 9) {
            console.log('Initial zoom in correct range, showing 3D markers');
            showThreeDMarkers();
          } else {
            console.log('Initial zoom not in correct range for 3D markers');
          }

          // Check initial zoom level for city markers
          if (
            map.current.getZoom() >= CITY_MARKERS_ZOOM_MIN &&
            map.current.getZoom() <= CITY_MARKERS_ZOOM_MAX
          ) {
            console.log('Initial zoom in correct range, showing city markers');
            showCityMarkers();
          } else {
            console.log('Initial zoom not in correct range for city markers');
            hideCityMarkers();
          }
        });
      } else {
        map.current.setCenter([lng, lat]);
        map.current.setZoom(zoom);
        if (controllerRef.current) {
          controllerRef.current.abort();
        }
        controllerRef.current = new AbortController();
        // Re-add site layers after removing them
        updateLayers();

        // Ensure zoom event listener is added
        map.current.off('zoom', handleZoomChange);
        map.current.on('zoom', handleZoomChange);
        console.log('Zoom event listener re-attached to existing map');

        // Add general map click handler to prevent unwanted zoom changes at high zoom levels
        map.current.off('click'); // Remove any existing click handlers to avoid duplicates
        map.current.on('click', (e) => {
          const currentZoom = map.current.getZoom();
          if (currentZoom >= 12) {
            // At high zoom levels, prevent automatic zoom changes
            // Only allow clicks on specific elements (popups, markers, etc.)
            const clickedElement = e.originalEvent.target;
            const isAllowedElement =
              clickedElement.closest('.mapboxgl-popup-content') ||
              clickedElement.closest('.region-marker') ||
              clickedElement.closest('.custom-marker') ||
              clickedElement.closest('.mapboxgl-marker') ||
              clickedElement.closest('.mapboxgl-popup-close-button');

            if (!isAllowedElement) {
              console.log('Preventing map click at high zoom level:', currentZoom);
              e.preventDefault();
              return;
            }
          }
        });

        // Check current zoom level for 3D markers
        console.log('Existing map zoom check - zoom level:', map.current.getZoom());
        if (map.current.getZoom() >= ZOOM_THRESHOLD_FOR_3D && map.current.getZoom() < 9) {
          console.log('Existing map zoom in correct range, showing 3D markers');
          showThreeDMarkers();
        } else {
          console.log('Existing map zoom not in correct range, hiding 3D markers');
          hideThreeDMarkers();
        }

        // Check current zoom level for city markers
        if (
          map.current.getZoom() >= CITY_MARKERS_ZOOM_MIN &&
          map.current.getZoom() <= CITY_MARKERS_ZOOM_MAX
        ) {
          console.log('Existing map zoom in correct range, showing city markers');
          showCityMarkers();
        } else {
          console.log('Existing map zoom not in correct range, hiding city markers');
          hideCityMarkers();
        }
      }
    }
  }, [isLoading, zoom, tab]); // Depend on 'tab' to trigger updates

  const updateLayers = (controller) => {
    // Force cleanup of all link layers first
    removeWmsLayer();
    removeWmsLayerMpbn();
    removeWmsSitesLayer();

    // Remove old event listeners before adding new ones
    map.current.off('mouseenter', 'linksLayers');
    map.current.off('mouseleave', 'linksLayers');
    map.current.off('click', 'linksLayers');
    map.current.off('mouseenter', 'linksLayerss');
    map.current.off('mouseleave', 'linksLayerss');
    map.current.off('click', 'linksLayerss');

    // Remove old layers & sources before adding new ones
    regions.forEach((region) => {
      if (map.current.getLayer(region.id)) {
        map.current.removeLayer(region.id);
      }
      if (map.current.getLayer(`${region.id}-dashed`)) {
        map.current.removeLayer(`${region.id}-dashed`);
      }
      if (map.current.getSource(region.id)) {
        map.current.removeSource(region.id);
      }
    });

    // 🛠 Remove old site layers & sources before adding new ones
    if (map.current.getLayer('site-layer')) {
      map.current.removeLayer('site-layer');
    }
    if (map.current.getSource('site-source')) {
      map.current.removeSource('site-source');
    }

    boundaryLayer();

    // Cancel all ongoing requests
    cancelAllRequests();
    controllerRef.current = new AbortController();

    // Add a small delay to ensure cleanup is complete before adding new layers
    setTimeout(() => {
      // Re-add site layers after removing them
      tab === 'mpbn' ? addWmsLayerMpbn(controller) : addWmsLayer(controller);
      addWmsSitesLayer(); // Ensure site layers are reloaded
    }, 100);
  };
  const addWmsSitesLayer = async () => {
    // Store the current tab to validate response
    if (tab === null) {
      return;
    }
    const requestTab = tab;

    try {
      if (map.current.getSource('sitesLayers')) {
        removeWmsSitesLayer();
      }
      if (!map.current.getSource('sitesLayers')) {
        // Check if tab changed before making API call
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before site layer API call, aborting');
          return;
        }

        // Create a new AbortController for this specific request
        const sitesController = new AbortController();
        const requestId = `sites-${requestTab}-${Date.now()}`;

        // Add to request manager
        addRequestToManager(requestId, sitesController);

        // Check if we need to abort this request (if tab changed)
        const checkAndAbort = () => {
          if (sessionStorage.getItem('selectedTab') !== requestTab) {
            console.log('Tab changed during site layer API call, aborting');
            sitesController.abort();
            removeRequestFromManager(requestId);
            return true;
          }
          return false;
        };

        const data = await geoServerSites(requestTab, sitesController.signal);

        // Remove from request manager after completion
        removeRequestFromManager(requestId);

        if (!data) {
          console.log('Site layer request aborted or failed');
          return;
        }

        // Validate that we're still on the same tab after API response
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed after site layer API response, aborting layer addition');
          return;
        }

        // Final check before adding the site layer
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before adding site layer, aborting');
          return;
        }

        map.current.addSource('sitesLayers', {
          type: 'geojson',
          data: data,
        });

        map.current.addLayer({
          id: 'sitesLayers',
          type: 'circle',
          source: 'sitesLayers',
          paint: {
            'circle-radius': 3.8 / 1.8,
            'circle-color': '#02367b',
            'circle-stroke-color': '#02367b',
            'circle-stroke-width': 2.5 / 1.8,
            'circle-stroke-opacity': 0.4,
            // 'circle-opacity': 0.5
          },
        });
        // Add event listeners to change cursor style
        map.current.on('mouseenter', 'sitesLayers', () => {
          map.current.getCanvasContainer().style.cursor = 'pointer';
        });

        map.current.on('mouseleave', 'sitesLayers', () => {
          map.current.getCanvasContainer().style.cursor = '';
        });
        map.current.on('click', 'sitesLayers', (e) => {
          const features = map.current.queryRenderedFeatures(e?.point, { layers: ['sitesLayers'] });

          if (!features?.length) {
            return;
          }

          const coordinates = features[0]?.geometry.coordinates.slice();
          const properties = features[0]?.properties;

          // Remove any existing site popup first
          if (sitePopupRef.current) {
            sitePopupRef.current.remove();
            sitePopupRef.current = null;
          }

          const popupHtml = `
          <div class="popup-container">
            <p class="popup-item"><strong>Site ID:</strong> ${properties?.['site_id'] || '--'}</p>
            <p class="popup-item"><strong>Region:</strong> ${properties?.region || '--'}</p>
            <p class="popup-item"><strong>City:</strong> ${properties?.city || '--'}</p>
          </div>
        `;

          setSitePopupFlag(true);

          sitePopupRef.current = new mapboxgl.Popup({ closeButton: true })
            .setLngLat(coordinates)
            .setHTML(popupHtml)
            .addTo(map.current)
            .on('close', () => {
              setSitePopupFlag(false);
              sitePopupRef.current = null;
            });

          // Check current zoom level before flying
          const currentZoom = map.current.getZoom();
          if (currentZoom < 14) {
            // Only zoom in if we're not already at a high zoom level
            map.current.flyTo({
              center: coordinates,
              zoom: 14, // Adjust zoom level as needed
            });
          }
        });
      }
    } catch (error) {
      console.error('Error adding WFS layer:', error);
    }
  };

  useEffect(() => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
    if (alramType === 'history') {
      // Re-add site layers after removing them
      tab === 'mpbn' ? addWmsLayerMpbn() : addWmsLayer();
      // tab === 'mpbn' ? addWmsLayerMpbn() : addWmsLayer();
    } else {
      // tab === 'mpbn' ? addWmsLayerMpbn(controllerRef.current) : addWmsLayer(controllerRef.current);
    }
  }, [alarmsData, alramType]);
  const boundaryLayer = () => {
    removeOldBoundaryLayers(regions, regionsMpbn, map);

    if (tab === 'ipran' || tab === 'otn' || tab === 'ftts') {
      regions.forEach((region) => {
        const lineLayerId = `${region.id}-border`;
        const fillLayerId = region.id;

        map.current.addSource(region.id, {
          type: 'geojson',
          data: region.data,
        });
        if (region.regionName !== 'Pakistan') {
          map.current.addLayer({
            id: fillLayerId,
            type: 'fill',
            source: region.id,
            paint: {
              'fill-color': region.color,
              'fill-opacity': 0.7,
            },
          });
        } else {
          map.current.addLayer({
            id: lineLayerId,
            type: 'line',
            source: region.id,
            paint: {
              'line-color': '#446363',
              'line-width': 2,
              'line-opacity': 0.7,
            },
          });
        }
      });
    }

    if (tab === 'mpbn') {
      regionsMpbn.forEach((region) => {
        const lineLayerId = `${region.id}-border`;
        const fillLayerIds = region.id;
        map.current.addSource(region.id, {
          type: 'geojson',
          data: region.data,
        });

        map.current.addLayer({
          id: lineLayerId,
          type: 'line',
          source: region.id,
          paint: {
            'line-color': region.color,
            'line-width': 3,
          },
        });
        // map.current.addLayer({
        //   id: fillLayerIds,
        //   type: 'fill',
        //   source: region.id,
        //   paint: {
        //     'fill-color': '#e39b88',
        //     'fill-opacity': 0.2,
        //   },
        // });
      });
    }
  };

  const createRegionMarkerElement = (cityName, number) => {
    const markerElement = document.createElement('div');
    markerElement.className = number > 0 ? 'region-marker' : ''; //region-marker-green

    // Add circular cutout for the image
    const imageCutout = document.createElement('div');
    imageCutout.className = number > 0 ? 'image-cutout' : '';
    markerElement.appendChild(imageCutout);

    // Add pin tip
    const pinTip = document.createElement('div');
    pinTip.className = 'pin-tip';
    markerElement.appendChild(pinTip);
    if (number > 0) {
      const numberElement = document.createElement('div');
      numberElement.className = number > 0 ? 'number' : '';
      numberElement.textContent = number;
      markerElement.appendChild(numberElement);
    }

    return markerElement;
  };

  const createCityMarkerElement = (iconUrl, cityName, number) => {
    const markerElement = document.createElement('div');
    markerElement.className = 'custom-marker';

    // Add number on top
    const numberElement = document.createElement('div');
    numberElement.className = number > 0 ? 'number' : '';
    numberElement.textContent = number;
    markerElement.appendChild(numberElement);

    const imageCutout = document.createElement('div');
    imageCutout.className = 'image-cutout';
    markerElement.appendChild(imageCutout);

    // Set background image for the cutout
    const image = document.createElement('img');
    image.src = iconUrl;
    imageCutout.appendChild(image);

    // Add pin tip
    const pinTip = document.createElement('div');
    pinTip.className = 'pin-tip';
    markerElement.appendChild(pinTip);

    // Add city name
    const cityNameElement = document.createElement('div');
    cityNameElement.className = 'city-name';
    cityNameElement.textContent = cityName;
    markerElement.appendChild(cityNameElement);

    return markerElement;
  };
  const createCityThreeDMarker = (lng, lat, alarmsCount, name) => {
    if (!map.current.getLayer(`3d-model-${lng}-${lat}`)) {
      const modelOrigin = [lng, lat];
      const modelAltitude = 6000;
      const modelRotate = [Math.PI / 2, 0, 0];
      const modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
        modelOrigin,
        modelAltitude
      );

      const scaleFactor = 3000; // Adjust this factor to increase the model size
      const modelTransform = {
        translateX: modelAsMercatorCoordinate.x,
        translateY: modelAsMercatorCoordinate.y,
        translateZ: modelAsMercatorCoordinate.z,
        rotateX: modelRotate[0],
        rotateY: modelRotate[1],
        rotateZ: modelRotate[2],
        scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * scaleFactor,
      };
      const startTime = Date.now();
      const customLayer = {
        id: `3d-model-${lng}-${lat}`,
        type: 'custom',
        renderingMode: '3d',
        onAdd: function (map, gl) {
          this.camera = new THREE.Camera();
          this.scene = new THREE.Scene();

          // Add ambient light
          const ambientLight = new THREE.AmbientLight(0x404040, 1); // soft white light with full intensity
          this.scene.add(ambientLight);

          // Add hemisphere light for even lighting
          const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.6);
          hemisphereLight.position.set(0, 200, 0);
          this.scene.add(hemisphereLight);

          // Add multiple directional lights
          const directionalLight1 = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight1.position.set(0, -70, 100).normalize();
          this.scene.add(directionalLight1);

          const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight2.position.set(0, 70, 100).normalize();
          this.scene.add(directionalLight2);

          const directionalLight3 = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight3.position.set(70, 0, 100).normalize();
          this.scene.add(directionalLight3);

          const directionalLight4 = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight4.position.set(-70, 0, 100).normalize();
          this.scene.add(directionalLight4);

          const directionalLight5 = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight5.position.set(100, 0, 100).normalize();
          this.scene.add(directionalLight5);

          // Add a top light
          const topLight = new THREE.DirectionalLight(0xffffff, 1);
          topLight.position.set(0, 200, 100).normalize(); // Positioned directly above the model
          this.scene.add(topLight);

          // Add point light
          const pointLight = new THREE.PointLight(0xffffff, 1, 100);
          pointLight.position.set(50, 50, 50);
          this.scene.add(pointLight);

          // Add spotlight
          const spotLight = new THREE.SpotLight(0xffffff);
          spotLight.position.set(15, 40, 35);
          spotLight.castShadow = true;
          this.scene.add(spotLight);

          const loader = new GLTFLoader();
          const modelPath = `/models/${name}.gltf`;
          console.log('Loading 3D model from:', modelPath);

          loader.load(
            modelPath,
            (gltf) => {
              console.log('3D model loaded successfully for:', name);
              const model = gltf.scene;

              // Preserve original materials
              model.traverse((node) => {
                if (node.isMesh) {
                  node.material = node.material.clone(); // Clone the existing material to ensure lighting compatibility
                  node.material.needsUpdate = true;
                }
              });

              this.scene.add(model);

              // Load the font and create the text
              const fontLoader = new FontLoader();
              if (alarmsCount > 0) {
                fontLoader.load(
                  'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json',
                  (font) => {
                    const textGeometry = new TextGeometry(`${alarmsCount}`, {
                      font: font,
                      size: 1,
                      height: 0.2,
                    });

                    const textMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
                    const textMesh = new THREE.Mesh(textGeometry, textMaterial);

                    // Adjust the position of the text to place it on top of the model
                    textMesh.position.set(0, 7, 0); // Adjust these values as necessary
                    this.scene.add(textMesh);
                  },
                  undefined,
                  (fontError) => {
                    console.error('Error loading font for', name, ':', fontError);
                  }
                );
              }
            },
            (progress) => {
              console.log(
                'Loading progress for',
                name,
                ':',
                (progress.loaded / progress.total) * 100 + '%'
              );
            },
            (error) => {
              console.error('Error loading 3D model for', name, ':', error);
              console.error('Model path was:', modelPath);
            }
          );

          this.map = map;

          this.renderer = new THREE.WebGLRenderer({
            canvas: map.getCanvas(),
            context: gl,
            antialias: true,
          });

          this.renderer.autoClear = false;

          // Initialize raycaster and mouse vector
          this.raycaster = new THREE.Raycaster();
          this.mouse = new THREE.Vector2();

          // Add click event listener
          map.getCanvas().addEventListener('click', (event) => {
            // Check if the click was on a region marker or other UI element
            const clickedElement = event.target;
            const isRegionMarker =
              clickedElement.closest('.region-marker') ||
              clickedElement.closest('.custom-marker') ||
              clickedElement.closest('.mapboxgl-marker');

            if (isRegionMarker) {
              return; // Don't process 3D marker click if clicking on a region marker
            }

            const rect = map.getCanvas().getBoundingClientRect();
            this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

            this.raycaster.setFromCamera(this.mouse, this.camera);

            const intersects = this.raycaster.intersectObjects(this.scene.children, true);
            if (intersects.length > 0) {
              // Only handle 3D model clicks, not general map clicks
              const clickedPoint = intersects[0].point;
              const clickedLngLat = map.unproject([event.clientX, event.clientY]);

              // Check if we're at a high zoom level before flying
              const currentZoom = map.getZoom();
              if (currentZoom >= 10) {
                // At high zoom, don't change the view - just show info or handle the 3D model click
                console.log('3D model clicked at high zoom level, maintaining current view');
                return;
              }

              map.flyTo({
                center: [clickedLngLat.lng, clickedLngLat.lat],
                zoom: 10,
                essential: true,
                duration: 2000,
              });
            }
          });
        },
        render: function (gl, matrix) {
          const rotationSpeed = 0.001;
          const currentTime = Date.now();
          const rotationY = rotationSpeed * (currentTime - startTime);
          const tiltX = Math.PI / 6; // Tilt angle on the X-axis (adjust this value)

          // Recalculate the modelTransform
          const modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
            modelOrigin,
            modelAltitude
          );
          const modelTransform = {
            translateX: modelAsMercatorCoordinate.x,
            translateY: modelAsMercatorCoordinate.y,
            translateZ: modelAsMercatorCoordinate.z,
            rotateX: modelRotate[0],
            rotateY: modelRotate[1] + rotationY, // Add the rotationY to the model's rotation
            rotateZ: modelRotate[2],
            scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * scaleFactor,
          };

          const m = new THREE.Matrix4().fromArray(matrix);
          const l = new THREE.Matrix4()
            .makeTranslation(
              modelTransform.translateX,
              modelTransform.translateY,
              modelTransform.translateZ
            )
            .scale(
              new THREE.Vector3(modelTransform.scale, -modelTransform.scale, modelTransform.scale)
            )
            .multiply(new THREE.Matrix4().makeRotationX(tiltX))
            .multiply(new THREE.Matrix4().makeRotationY(rotationY));

          this.camera.projectionMatrix = m.multiply(l);
          this.renderer.resetState();
          this.renderer.render(this.scene, this.camera);
          this.map.triggerRepaint();
        },
      };
      map.current.addLayer(customLayer);
    }
  };

  const addCityMarkers = (center) => {
    // This function is now deprecated - city markers are managed by zoom level
    // Use showCityMarkers() and hideCityMarkers() instead
    console.log('addCityMarkers called - use showCityMarkers() instead');
  };
  const addAlarmMarker = (center) => {
    if (alarmMarker.current.length > 0) {
      removeAlarmsMarker();
    }
    const alarmMarkers = new mapboxgl.Marker().setLngLat(center).addTo(map.current);
    alarmMarker.current.push(alarmMarkers);
  };

  const removeCityMarkers = () => {
    cityMarkers.current.forEach((marker) => marker.remove());
    cityMarkers.current = [];
    // showRegionMarkers(); // Show region markers
  };

  const updateLayerSourceOnly = async () => {
    const currentTab = sessionStorage.getItem('selectedTab');
    const requestTab = tab;

    if (currentTab !== tab) {
      return;
    }

    const isMpbn = tab === 'mpbn';
    const sourceId = isMpbn ? 'linksLayerss' : 'linksLayers';

    try {
      // Create a new AbortController for this specific request
      const updateController = new AbortController();
      const requestId = `update-${requestTab}-${Date.now()}`;

      // Add to request manager
      addRequestToManager(requestId, updateController);

      // Check if we need to abort this request (if tab changed)
      const checkAndAbort = () => {
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed during layer source update, aborting');
          updateController.abort();
          removeRequestFromManager(requestId);
          return true;
        }
        return false;
      };

      const data = await geoServerLinks(requestTab, updateController.signal);

      // Remove from request manager after completion
      removeRequestFromManager(requestId);
      if (!data) {
        return;
      }

      // Final validation before updating the source
      if (sessionStorage.getItem('selectedTab') !== requestTab) {
        console.log('Tab changed before updating layer source, aborting');
        return;
      }

      if (map.current.getSource(sourceId)) {
        map.current.getSource(sourceId).setData(data);
        console.log(`[Map] Layer source "${sourceId}" updated on alarm change`);
      } else {
        console.warn(`[Map] Source "${sourceId}" not found, skipping update`);
      }
    } catch (err) {
      console.error('[Map] Failed to update source data:', err);
    }
  };

  useEffect(() => {
    if (alramType !== 'live') {
      return;
    }

    let hasChanged = false;

    if (JSON.stringify(alarmsData) !== JSON.stringify(prevAlarmData.current)) {
      hasChanged = true;
      prevAlarmData.current = alarmsData;
    }

    if (hasChanged) {
      updateLayerSourceOnly();

      hasChanged = false;
    }
  }, [alarmsData]);

  const addWmsLayer = async (controller) => {
    if (tab !== 'otn' && tab !== 'ipran' && tab !== 'ftts') {
      return;
    }

    // Store the current tab to validate response
    const requestTab = tab;

    try {
      // Double-check that we're still on the correct tab before proceeding
      const currentTab = sessionStorage.getItem('selectedTab');
      if (currentTab !== tab) {
        console.log('Tab changed during layer loading, aborting');
        return;
      }

      if (map.current.getSource('linksLayers')) {
        removeWmsLayer();
        removeWmsLayerMpbn();
      }
      if (!map.current.getSource('linksLayers')) {
        // Check again before making the API call
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before API call, aborting');
          return;
        }

        // Create a new AbortController for this specific request
        const linksController = new AbortController();
        const requestId = `links-${requestTab}-${Date.now()}`;

        // Add to request manager
        addRequestToManager(requestId, linksController);

        // Check if we need to abort this request (if tab changed)
        const checkAndAbort = () => {
          if (sessionStorage.getItem('selectedTab') !== requestTab) {
            console.log('Tab changed during links API call, aborting');
            linksController.abort();
            removeRequestFromManager(requestId);
            return true;
          }
          return false;
        };

        const data = await geoServerLinks(requestTab, linksController.signal);

        // Remove from request manager after completion
        removeRequestFromManager(requestId);

        if (!data) {
          console.log('Links layer request aborted or failed');
          return;
        }

        // Validate that we're still on the same tab after API response
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed after API response, aborting layer addition');
          return;
        }

        if (tab !== 'otn' && tab !== 'ipran' && tab !== 'ftts') {
          return;
        }
        const updatedData = {
          ...data,
          features: data.features.map((feature) => ({
            ...feature,
            properties: {
              ...feature.properties,
              color: alarmsData.some((alarm) => alarm.layer_name === feature.properties.layer_name)
                ? color.trim()
                : 'green',
            },
          })),
        };

        // Final check before adding the layer
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before adding layer, aborting');
          return;
        }

        map.current.addSource('linksLayers', {
          type: 'geojson',
          data: alramType === 'history' ? updatedData : data,
        });
        map.current.addLayer({
          id: 'linksLayers',
          type: 'line',
          source: 'linksLayers',
          paint: {
            'line-color': [
              'case',
              ['==', ['downcase', ['get', 'color']], color.trim()],
              '#e85879',
              ['get', 'color'],
            ],
            'line-opacity': ['case', ['==', ['downcase', ['get', 'color']], 'green'], 0.4, 1],
            'line-width': 3,
            'line-offset': ['case', ['==', ['get', 'color'], color.trim()], 5, 0],
          },
        });

        map.current.addLayer({
          type: 'line',
          source: 'linksLayers',
          id: 'linksLayers-dashed',
          paint: {
            'line-color': [
              'case',
              ['==', ['get', 'color'], color.trim()],
              '#b62949',
              ['get', 'color'],
            ],
            'line-width': 3,
            'line-dasharray': [0, 4, 3],
            'line-offset': ['case', ['==', ['get', 'color'], color.trim()], 5, 0],
          },
        });

        const dashArraySequence = [
          [0, 4, 3],
          [0.5, 4, 2.5],
          [1, 4, 2],
          [1.5, 4, 1.5],
          [2, 4, 1],
          [2.5, 4, 0.5],
          [3, 4, 0],
          [0, 0.5, 3, 3.5],
          [0, 1, 3, 3],
          [0, 1.5, 3, 2.5],
          [0, 2, 3, 2],
          [0, 2.5, 3, 1.5],
          [0, 3, 3, 1],
          [0, 3.5, 3, 0.5],
        ];

        const animateDashArray = (timestamp) => {
          const layerId = 'linksLayers-dashed';

          if (!map.current.getLayer(layerId)) {
            // If the layer doesn't exist, skip this frame
            requestAnimationFrame(animateDashArray);
            return;
          }
          const newStep = parseInt((timestamp / 120) % dashArraySequence.length);

          map.current.setPaintProperty(
            'linksLayers-dashed',
            'line-dasharray',
            dashArraySequence[stepRef.current]
          );
          stepRef.current = newStep;

          requestAnimationFrame(animateDashArray);
        };

        // animateDashArray(0);
        if (map?.current.getLayer('linksLayers-dashed')) {
          animateDashArray(0);
        }

        if (tab !== 'otn' && tab !== 'ipran' && tab !== 'ftts') {
          return;
        }
        map.current.on('mouseenter', 'linksLayers', () => {
          map.current.getCanvasContainer().style.cursor = 'pointer';
        });
        map.current.on('mouseenter', 'linksLayers', (e) => {
          // Only show tooltip for non-MPBN tabs
          if (tab !== 'mpbn') {
            const feature = map.current.queryRenderedFeatures(e.point, {
              layers: ['linksLayers'],
            })[0];
            if (feature) {
              const properties = feature?.properties;
              const lng = e.lngLat;
              const tooltipHtml = `
                <div class="tooltip-container">
                  <div class="title_container_tooltip">
                    <div class="title_text_container_tooltip">
                      <h3 class="tooltip-heading">${properties?.layer_name || '--'}</h3>
                      <p class="tooltip-item">Length (km): ${properties?.length?.toFixed(2) || '--'}</p>
                      <p class="popup-item"><strong>Commission Date:</strong> ${
                        properties?.commissioned_at
                          ? new Date(properties.commissioned_at).toLocaleDateString('en-GB')
                          : '--'
                      }</p>
                    </div>               
                  </div>
                </div>
              `;

              // Create a tooltip or popup with the feature details
              currentPopup = new mapboxgl.Popup({ closeButton: false })
                .setLngLat(lng) // Create a valid LngLatLike object
                .setHTML(tooltipHtml)
                .addTo(map.current);
            }
          }
        });

        map.current.on('mouseleave', 'linksLayers', () => {
          map.current.getCanvasContainer().style.cursor = '';
          if (currentPopup) {
            currentPopup.remove();
            currentPopup = null;
          }
        });

        // Add click event to zoom to complete layer
        map.current.on('click', 'linksLayers', (e) => {
          const features = map.current.queryRenderedFeatures(e.point, {
            layers: ['linksLayers'],
          });

          if (!features.length) {
            return;
          }

          const clickedFeature = features[0];
          const layerName = clickedFeature.properties.layer_name;

          // Find all features with the same layer_name to get the complete layer
          const allFeatures = map.current.querySourceFeatures('linksLayers');
          const layerFeatures = allFeatures.filter(
            (feature) => feature.properties.layer_name === layerName
          );

          if (layerFeatures.length > 0) {
            // Create a feature collection with all features of the same layer
            const featureCollection = {
              type: 'FeatureCollection',
              features: layerFeatures,
            };

            // Calculate the bounding box of the complete layer
            const bbox = turf.bbox(featureCollection);

            // Add some padding to the bounding box for better visibility
            const padding = 0.1; // Adjust this value for more or less padding
            const paddedBbox = [
              bbox[0] - padding,
              bbox[1] - padding,
              bbox[2] + padding,
              bbox[3] + padding,
            ];

            // Check current zoom level before flying
            const currentZoom = map.current.getZoom();
            if (currentZoom < 14) {
              // Only zoom in if we're not already at a high zoom level
              map.current.flyTo({
                center: e.lngLat,
                zoom: 14, // Same zoom level as site click
                duration: 2000,
                essential: true,
              });

              // Check zoom level after animation completes to show/hide 3D markers
              setTimeout(() => {
                handleZoomChange();
              }, 2100);
            }
          }
        });
      }
    } catch (error) {
      console.error('Error adding WFS layer:', error);
    }
  };
  const addWmsLayerMpbn = async (controller) => {
    if (tab !== 'mpbn') {
      return;
    }

    // Store the current tab to validate response
    const requestTab = tab;

    try {
      // Double-check that we're still on the correct tab before proceeding
      const currentTab = sessionStorage.getItem('selectedTab');
      if (currentTab !== tab) {
        console.log('Tab changed during MPBN layer loading, aborting');
        return;
      }

      if (map.current.getSource('linksLayerss')) {
        removeWmsLayer();
        removeWmsLayerMpbn();
      }

      if (!map.current.getSource('linksLayerss')) {
        // Check again before making the API call
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before MPBN API call, aborting');
          return;
        }

        // Create a new AbortController for this specific request
        const mpbnLinksController = new AbortController();
        const requestId = `mpbn-links-${requestTab}-${Date.now()}`;

        // Add to request manager
        addRequestToManager(requestId, mpbnLinksController);

        // Check if we need to abort this request (if tab changed)
        const checkAndAbort = () => {
          if (sessionStorage.getItem('selectedTab') !== requestTab) {
            console.log('Tab changed during MPBN links API call, aborting');
            mpbnLinksController.abort();
            removeRequestFromManager(requestId);
            return true;
          }
          return false;
        };

        const data = await geoServerLinks(requestTab, mpbnLinksController.signal);

        // Remove from request manager after completion
        removeRequestFromManager(requestId);

        if (!data) {
          console.log('MPBN links layer request aborted or failed');
          return;
        }

        // Validate that we're still on the same tab after API response
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed after MPBN API response, aborting layer addition');
          return;
        }

        const updatedData = {
          ...data,
          features: data.features.map((feature) => ({
            ...feature,
            properties: {
              ...feature.properties,
              color: alarmsData.some((alarm) => alarm.trunk_name === feature.properties.trunk_name)
                ? color.trim()
                : 'green',
            },
          })),
        };

        // Final check before adding the MPBN layer
        if (sessionStorage.getItem('selectedTab') !== requestTab) {
          console.log('Tab changed before adding MPBN layer, aborting');
          return;
        }

        map.current.addSource('linksLayerss', {
          type: 'geojson',
          data: alramType === 'history' ? updatedData : data,
        });

        map.current.addLayer({
          id: 'linksLayerss',
          type: 'line',
          source: 'linksLayerss',
          paint: {
            'line-color': [
              'case',
              ['==', ['downcase', ['get', 'color']], color.trim()],
              '#e85879',
              ['get', 'color'],
            ],
            'line-opacity': ['case', ['==', ['downcase', ['get', 'color']], 'green'], 0.4, 1],
            'line-width': 3,
            'line-offset': [
              'interpolate',
              ['exponential', 1.5],
              ['zoom'],
              5,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                6,
                -6,
              ],
              10,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                12,
                -12,
              ],
              15,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                24,
                -24,
              ],
            ],
          },
        });
        map.current.addLayer({
          type: 'line',

          source: 'linksLayerss',

          id: 'linksLayerss-dashed',

          paint: {
            'line-color': [
              'case',
              ['==', ['get', 'color'], color.trim()],
              '#b62949',
              ['get', 'color'],
            ],

            'line-width': 3,

            'line-dasharray': [0, 4, 3],
            'line-offset': [
              'interpolate',
              ['exponential', 1.5],
              ['zoom'],
              5,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                6,
                -6,
              ],
              10,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                12,
                -12,
              ],
              15,
              [
                'case',
                ['==', ['downcase', ['get', 'color']], 'green'],
                0,
                ['==', ['downcase', ['get', 'color']], 'red'],
                24,
                -24,
              ],
            ],
          },
        });
        const dashArraySequence = [
          [0, 4, 3],
          [0.5, 4, 2.5],
          [1, 4, 2],
          [1.5, 4, 1.5],
          [2, 4, 1],
          [2.5, 4, 0.5],
          [3, 4, 0],
          [0, 0.5, 3, 3.5],
          [0, 1, 3, 3],
          [0, 1.5, 3, 2.5],
          [0, 2, 3, 2],
          [0, 2.5, 3, 1.5],
          [0, 3, 3, 1],
          [0, 3.5, 3, 0.5],
        ];
        const animateDashArray = (timestamp) => {
          const layerId = 'linksLayers-dashed';

          if (!map.current.getLayer(layerId)) {
            // If the layer doesn't exist, skip this frame
            requestAnimationFrame(animateDashArray);
            return;
          }
          const newStep = parseInt((timestamp / 120) % dashArraySequence.length);
          map.current.setPaintProperty(
            'linksLayerss-dashed',
            'line-dasharray',
            dashArraySequence[stepRef.current]
          );
          stepRef.current = newStep;
          requestAnimationFrame(animateDashArray);
        };
        if (map?.current?.getLayer('linksLayerss-dashed')) {
          animateDashArray(0);
        }
        const popupDisplayDelay = 1000;
        let popupTimer = null;
        map.current.on('mouseenter', 'linksLayerss', async (e) => {
          if (tab !== 'mpbn') {
            return;
          }
          map.current.getCanvasContainer().style.cursor = 'pointer';
          if (popupTimer) {
            clearTimeout(popupTimer);
          }
          popupTimer = setTimeout(async () => {
            removeCurrentPopup();
            const features = map.current.queryRenderedFeatures(e.point, {
              layers: ['linksLayerss'],
            });
            if (!features.length) {
              return;
            }
            const feature = features[0];
            const properties = feature?.properties;
            const lng = e.lngLat;
            const trunksData = await GetToolTipData(properties?.trunk_name);

            // Get trunk details from the first item (since all items have same trunk info)
            const trunkInfo = trunksData?.trunkDetails?.[0];
            const totalLinks = trunksData?.trunkDetails?.length || 0;

            // Count broken links (assuming red color indicates broken)
            const brokenLinks =
              trunksData?.trunkDetails?.filter(
                (link) => link?.layer_color === 'red' || link?.color === 'red'
              ).length || 0;

            // Create links details HTML
            const linksHtml =
              trunksData?.trunkDetails
                ?.map(
                  (link, index) => `
                <div style="
                  border: 1px solid #e1e5e9; 
                  border-radius: 8px; 
                  padding: 12px; 
                  margin-bottom: 10px; 
                  background-color: #fafbfc;
                  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                ">
                  <div style="
                    display: flex; 
                    align-items: center; 
                    margin-bottom: 8px;
                    flex-wrap: wrap;
                  ">
                    <strong style="
                      flex: 1; 
                      color: #333; 
                      font-size: 12px;
                      line-height: 1.3;
                      word-break: break-word;
                    ">${link?.layer_name || `Link ${index + 1}`}</strong> 
                    <span style="
                      display: inline-block; 
                      width: 12px; 
                      height: 12px; 
                      background-color: ${link?.layer_color || link?.color || 'green'};
                      border-radius: 50%; 
                      margin-left: 8px;
                      flex-shrink: 0;
                      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                      border: 2px solid #ffffff;
                    "></span>
                  </div>
                  <div style="
                    font-size: 10px; 
                    color: #666;
                    line-height: 1.4;
                  ">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-bottom: 6px;">
                      <div style="white-space: nowrap;"><strong>Source:</strong> ${link?.source_city} (${link?.source_site_code})</div>
                      <div style="white-space: nowrap;"><strong>Sink:</strong> ${link?.sink_city} (${link?.sink_site_code})</div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-bottom: 6px;">
                      <div style="white-space: nowrap;"><strong>Bandwidth:</strong> ${link?.bandwidth || '--'}</div>
                      <div style="white-space: nowrap;"><strong>Service:</strong> ${link?.service_type || '--'}</div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
                      <div style="white-space: nowrap;"><strong>Media:</strong> ${link?.media || '--'}</div>
                      <div style="white-space: nowrap;"><strong>Plane:</strong> ${link?.plane || '--'}</div>
                    </div>
                  </div>
                </div>
              `
                )
                .join('') || '';

            const popupHtml = `
              <!-- Close button -->
              <button id="popup-close-btn" style="
                position: absolute; 
                top: 4px; 
                right: 4px; 
                background: rgba(255,255,255,0.9); 
                border: none; 
                outline: none;
                font-size: 18px; 
                cursor: pointer;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10;
                color: #666;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
              ">&times;</button>
              
              <!-- Top color bar -->
              <div style="
                width: 100%; 
                height: 6px; 
                background-color: ${trunkInfo?.color || 'green'};
                margin-top: 20px;
                margin-bottom: 12px;
                border-radius: 3px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
              "></div>
              
              <!-- Trunk title -->
              <h3 style="
                font-size: 14px; 
                margin: 0 0 12px 0; 
                color: #333;
                font-weight: 600;
              ">${properties?.trunk_name || '--'}</h3>
              
              <!-- Trunk Summary -->
              <div style="
                background-color: #f0f8ff; 
                padding: 16px; 
                border-radius: 8px; 
                margin-bottom: 16px;
                border: 1px solid #d1e7ff;
                box-shadow: 0 2px 8px rgba(0,0,0,0.06);
              ">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; font-size: 12px;">
                  <div style="white-space: nowrap;"><strong>Length:</strong> ${trunkInfo?.length ? parseFloat(trunkInfo.length).toFixed(2) + ' km' : '--'}</div>
                  <div style="white-space: nowrap;"><strong>Total Links:</strong> ${totalLinks}</div>
                  <div style="white-space: nowrap;"><strong>Broken:</strong> ${brokenLinks}</div>
                  <div style="white-space: nowrap;"><strong>Region:</strong> ${trunkInfo?.region || '--'}</div>
                  </div>               
                <div style="margin-top: 8px; font-size: 12px;">
                  <strong>Aggregated BW:</strong> ${trunkInfo?.aggregated_bw || '--'}
                </div>
              </div>
              
              <!-- Links Details -->
              <div>
                <h4 style="
                  font-size: 12px; 
                  margin: 0 0 8px 0; 
                  color: #333; 
                  border-bottom: 1px solid #ddd; 
                  padding-bottom: 4px;
                  font-weight: 600;
                ">Links Details:</h4>
                <div style="max-height: 200px; overflow-y: auto; border: 1px solid #e1e5e9; border-radius: 4px; padding: 8px;">
                  ${linksHtml}
                </div>
              </div>
            `;
            setPopupFlag(true);

            currentPopupRef.current = new mapboxgl.Popup({
              closeButton: false,
              maxWidth: '400px',
              className: 'custom-popup',
            })
              .setLngLat(lng)
              .setHTML(popupHtml)
              .addTo(map.current);

            // Add close button event listener
            setTimeout(() => {
              const closeButton = document.getElementById('popup-close-btn');
              if (closeButton) {
                closeButton.addEventListener('click', (event) => {
                  event.stopPropagation();
                  removeCurrentPopup();
                });
              }
            }, 100);
          }, popupDisplayDelay);
        });

        map.current.on('mouseleave', 'linksLayerss', () => {
          map.current.getCanvasContainer().style.cursor = '';
          if (popupTimer) {
            clearTimeout(popupTimer);
          }
        });

        // Click outside closes popup
        map.current.on('click', (e) => {
          const clickedInsidePopup = e.originalEvent.target.closest('.mapboxgl-popup-content');
          const clickedCloseButton = e.originalEvent.target.id === 'popup-close-btn';
          if (!clickedInsidePopup || clickedCloseButton) {
            removeCurrentPopup();
          }

          // Prevent unwanted zoom changes at high zoom levels when clicking on empty areas
          const currentZoom = map.current.getZoom();
          if (currentZoom >= 12) {
            // At high zoom levels, prevent any automatic zoom changes from map clicks
            e.preventDefault();
            return;
          }
        });
      }
    } catch (error) {
      console.error('Error adding WFS layer:', error);
    }
  };

  const removeCurrentPopup = () => {
    if (currentPopupRef.current) {
      currentPopupRef.current.remove();
      currentPopupRef.current = null;
    }
    setPopupFlag(false);

    setLinkPopupFlag(false);
    if (popupTimer) {
      clearTimeout(popupTimer);
    }
  };

  const removeSitePopup = () => {
    if (sitePopupRef.current) {
      sitePopupRef.current.remove();
      sitePopupRef.current = null;
      setSitePopupFlag(false);
    }
  };
  const GetToolTipData = async (layerName) => {
    try {
      const responseData = await apiClient.get(`/mpbn/trunkLinksData/`, {
        params: { linkName: layerName },
      });
      return responseData.data.response;
    } catch (error) {
      handleApiError(error);
    }
  };

  const removeWmsLayer = () => {
    if (map.current) {
      // Remove all link layers and sources
      if (map.current.getLayer('linksLayers')) {
        map.current.removeLayer('linksLayers');
      }
      if (map.current.getLayer('linksLayers-dashed')) {
        map.current.removeLayer('linksLayers-dashed');
      }
      if (map.current.getSource('linksLayers')) {
        map.current.removeSource('linksLayers');
      }

      // Remove event listeners
      map.current.off('mouseenter', 'linksLayers');
      map.current.off('mouseleave', 'linksLayers');
      map.current.off('click', 'linksLayers');
    }
  };
  const removeWmsLayerMpbn = () => {
    if (map.current) {
      // Remove all MPBN link layers and sources
      if (map.current.getLayer('linksLayerss')) {
        map.current.removeLayer('linksLayerss');
      }
      if (map.current.getLayer('linksLayerss-dashed')) {
        map.current.removeLayer('linksLayerss-dashed');
      }
      if (map.current.getSource('linksLayerss')) {
        map.current.removeSource('linksLayerss');
      }

      // Remove event listeners
      map.current.off('mouseenter', 'linksLayerss');
      map.current.off('mouseleave', 'linksLayerss');
      map.current.off('click', 'linksLayerss');
    }
  };

  const removeWmsSitesLayer = () => {
    if (map.current.getSource('sitesLayers')) {
      map.current.removeLayer('sitesLayers');
      map.current.removeSource('sitesLayers');
    }
  };
  const removeThreeDLayer = (lng, lat) => {
    if (map.current.getLayer(`3d-model-${lng}-${lat}`)) {
      map.current.removeLayer(`3d-model-${lng}-${lat}`);
    }
  };

  const removeRegionMarkers = () => {
    regionMarkers.current.forEach((marker) => marker.remove());
    regionMarkers.current = [];
  };
  const removeAlarmsMarker = () => {
    if (alarmMarker.current.length > 0) {
      alarmMarker.current.forEach((marker) => marker.remove());
      alarmMarker.current = [];
    }
  };

  const showRegionMarkers = () => {
    // Clear existing region markers
    regionMarkers.current.forEach((marker) => marker.remove());
    regionMarkers.current = [];
    if (tab === 'mpbn') {
      regionsMpbn.forEach((region) => {
        const alarmsCount = data?.filter(
          (alarm) => (alarm.trunk_region || alarm.region) === region.regionName
        ).length;

        const regionMarker = new mapboxgl.Marker({
          element: createRegionMarkerElement('N1', alarmsCount),
        })
          .setLngLat(region.center)
          .addTo(map.current);

        regionMarkers.current.push(regionMarker);

        regionMarker.getElement().addEventListener('click', () => {
          setLng(region.center[0]);
          setLat(region.center[1]);
          console.log('Clicked region::', region.regionName, region.center);
          map.current.flyTo({
            center: region.center,
            zoom: 8,
            essential: true,
            duration: 2000,
          });
          // addCityMarkers(region.center);
        });
      });
    } else if (tab === 'ipran' || tab === 'otn' || tab === 'ftts') {
      regions.forEach((region) => {
        let alarmsCount = 0;
        if (tab === 'otn' || tab === 'ftts') {
          alarmsCount = data?.filter((alarm) => alarm.region === region.regionName).length;
        } else if (tab === 'mpbn') {
          alarmsCount = data?.filter((alarm) => alarm.region === region.regionName).length;
        } else if (tab === 'ipran') {
          // For IPRAN, check both source_region and region fields
          alarmsCount = data?.filter(
            (alarm) => (alarm.source_region || alarm.region) === region.regionName
          ).length;
        }
        const regionMarker = new mapboxgl.Marker({
          element: createRegionMarkerElement('N1', alarmsCount),
        })
          .setLngLat(region.center)
          .addTo(map.current);

        regionMarkers.current.push(regionMarker);

        regionMarker.getElement().addEventListener('click', () => {
          if (tab === 'mpbn') {
            return;
          }

          setLng(region.center[0]);
          setLat(region.center[1]);

          map.current.flyTo({
            center: region.center,
            zoom: 8,
            essential: true,
            duration: 2000,
          });

          // addCityMarkers(region.center);
        });
      });
    }
  };

  // const showRegionMarkers = () => {
  //   // Clear existing region markers
  //   regionMarkers.current.forEach((marker) => marker.remove());
  //   regionMarkers.current = [];

  //   const isMpbn = tab === 'mpbn';
  //   const filteredRegions = isMpbn ? regionsMpbn : regions;

  //   filteredRegions.forEach((region) => {
  //     if (!region?.center) {
  //       return;
  //     }

  //     const alarmsCount =
  //       tab === 'ipran'
  //         ? data?.filter((alarm) => alarm.source_region === region.regionName).length
  //         : data?.filter((alarm) => alarm.region === region.regionName).length;

  //     const regionMarker = new mapboxgl.Marker({
  //       element: createRegionMarkerElement('N1', alarmsCount),
  //     })
  //       .setLngLat(region.center)
  //       .addTo(map.current);

  //     regionMarkers.current.push(regionMarker);

  //     if (!isMpbn) {
  //       regionMarker.getElement().addEventListener('click', () => {
  //         setLng(region.center[0]);
  //         setLat(region.center[1]);
  //         map.current.flyTo({
  //           center: region.center,
  //           zoom: 8,
  //           essential: true,
  //           duration: 2000,
  //         });
  //         addCityMarkers(region.center);
  //       });
  //     }
  //   });
  // };

  const handleChange = (value) => {
    setAlramType(value);
    handleReset();
    handleRefresh();
  };
  function formatDuration(value) {
    const hours = Math.floor(value / 3600); // Calculate hours
    const minutes = Math.floor((value % 3600) / 60); // Calculate remaining minutes
    return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
  }
  const handleMouseEnter = () => {
    setPlayerHover(true);
  };

  const handleMouseLeave = () => {
    setPlayerHover(false);
  };

  const PlayVideo = (value) => {
    if (value < 0) {
      return;
    }
    setPosition(value);
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');

    const isCurrentDate = mapSelectedDate.isSame(dayjs(), 'day');
    const now = dayjs();
    const twentyFourHoursAgoTime = isCurrentDate
      ? mapSelectedDate.subtract(24, 'hour').add(value, 'seconds')
      : mapSelectedDate.add(value, 'seconds');

    setVideoPlayTime(
      `${twentyFourHoursAgoTime.format('YYYY-MM-DD')} ${twentyFourHoursAgoTime.format('HH:mm:ss')}`
    );
  };

  const PlayPause = () => {
    if (paused) {
      setPaused(false);
      const interval = setInterval(() => {
        setPosition((prevPosition) => {
          const newPosition = prevPosition + 900;
          if (newPosition >= duration) {
            clearInterval(interval);
            setPaused(true);
            return duration;
          }
          PlayVideo(newPosition);
          return newPosition;
        });
      }, 5000);
      setIntervalID(interval);
    } else {
      // Pause playing
      clearInterval(intervalID);
      setPaused(true);
    }
  };

  const renderHeader = useMemo(
    () => (
      <div
        style={{
          position: 'absolute',
          zIndex: 1,
          marginLeft: '32px',
          marginRight: '32px',
          marginTop: '20px',
          width: '-webkit-fill-available',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            height: '44px',
          }}
        >
          <div className="flex">
            <a
              id="switch_on"
              className={`toggleStyle ${alramType === 'live' ? 'selected' : 'not_selected'}`}
              onClick={() => handleChange('live')}
            >
              Live Alarms
            </a>
            <a
              id="switch_off"
              className={`toggleStyle ${alramType === 'history' ? 'selected' : 'not_selected'}`}
              onClick={() => handleChange('history')}
            >
              History Alarms
            </a>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <div style={{ background: '#F8E8E9' }}>
              {alramType === 'history' && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // label="Date Range"
                    name="birthDate"
                    value={mapSelectedDate}
                    data-testid="map-component-1"
                    onChange={handleDateChange}
                    sx={{ height: 44, '& .MuiInputBase-root': { height: 44 } }}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    maxDate={today}
                  />
                </LocalizationProvider>
              )}
            </div>
            <div className="flex-table">
              <a
                className={state.right ? 'table-icons' : 'table-icon'}
                onClick={toggleDrawer('right', true)}
              >
                <Tooltip title="Filter">
                  <TuneIcon />
                </Tooltip>
              </a>
            </div>
            <div className="flex-table">
              <a
                className={viewType === 'graph' ? 'table-icons' : 'table-icon-single'}
                onClick={() => setViewType('graph')}
              >
                <Tooltip title="Map">
                  <MapIcon />
                </Tooltip>
              </a>
              <a
                className={viewType === 'table' ? 'table-icons' : 'table-icon-single'}
                onClick={() => setViewType('table')}
              >
                <Tooltip title="Table">
                  <TableChartIcon />
                </Tooltip>
              </a>
            </div>
          </div>
        </Box>
      </div>
    ),
    [alramType, handleChange, setViewType]
  );

  const renderFooter = useMemo(
    () => (
      <>
        <div
          style={{
            position: 'absolute',
            marginLeft: '32px',
            marginBottom: '20px',
            zIndex: 1,
            width: '-webkit-fill-available',
            bottom: 0,
            left: 0,
          }}
        >
          {alramType === 'history' && (
            <Widget
              onMouseEnter={() => setPlayerHover(true)}
              onMouseLeave={() => setPlayerHover(false)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                width: playerHover ? 343 : 100,
              }}
            >
              {!playerHover ? (
                <>
                  <IconButton
                    aria-label={paused ? 'play' : 'pause'}
                    onClick={() => PlayPause(paused)}
                    sx={{ padding: '4px', border: '2px solid #FFF', mr: 2 }}
                  >
                    {paused ? (
                      <PlayArrowRounded
                        sx={{ fontSize: '1.5rem', color: '#BD1D23' }}
                        htmlColor={mainIconColor}
                      />
                    ) : (
                      <PauseRounded
                        sx={{ fontSize: '1.5rem', color: '#FDCA1C' }}
                        htmlColor={mainIconColor}
                      />
                    )}
                  </IconButton>
                  <Box
                    sx={{ width: 8, height: 8, backgroundColor: '#BD1D23', borderRadius: '8px' }}
                  />
                  <TinyText>{formatDuration(position)}</TinyText>
                </>
              ) : (
                <Box sx={{ width: '100%' }}>
                  <Slider
                    aria-label="time-indicator"
                    size="small"
                    value={position}
                    min={0}
                    step={900}
                    max={duration}
                    onChange={(_, value) => PlayVideo(value)}
                    sx={{
                      color: '#BD1D23',
                      height: 6.5,
                      '& .MuiSlider-thumb': { display: 'none' },
                      '& .MuiSlider-rail': { opacity: 0.28 },
                    }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: -2,
                    }}
                  >
                    <TinyText>{formatDuration(position)}</TinyText>
                    <TinyText>-{formatDuration(duration - position)}</TinyText>
                  </Box>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: -1 }}
                  >
                    <IconButton
                      aria-label="previous song"
                      onClick={() => PlayVideo(position - 900)}
                    >
                      <FastRewindRounded
                        fontSize="large"
                        htmlColor={mainIconColor}
                        sx={{ fontSize: '1.5rem', color: '#FFFFFF' }}
                      />
                    </IconButton>
                    <IconButton
                      aria-label={paused ? 'play' : 'pause'}
                      onClick={() => PlayPause(paused)}
                      sx={{ padding: '4px', border: '2px solid #FFF' }}
                    >
                      {paused ? (
                        <PlayArrowRounded
                          sx={{ fontSize: '1.5rem', color: '#BD1D23' }}
                          htmlColor={mainIconColor}
                        />
                      ) : (
                        <PauseRounded
                          sx={{ fontSize: '1.5rem', color: '#FDCA1C' }}
                          htmlColor={mainIconColor}
                        />
                      )}
                    </IconButton>
                    <IconButton aria-label="next song" onClick={() => PlayVideo(position + 900)}>
                      <FastForwardRounded
                        fontSize="large"
                        htmlColor={mainIconColor}
                        sx={{ fontSize: '1.5rem', color: '#FFFFFF' }}
                      />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </Widget>
          )}
        </div>
        <RefreshButton handleRefresh={handleRefresh} />
      </>
    ),
    [
      alramType,
      playerHover,
      paused,
      position,
      mainIconColor,
      duration,
      PlayPause,
      PlayVideo,
      formatDuration,
    ]
  );

  // Function to show 3D markers
  const showThreeDMarkers = () => {
    if (threeDMarkersVisible) {
      console.log('3D markers already visible, skipping');
      return; // Already visible
    }

    console.log('Creating 3D markers for cities');
    console.log('Cities data available:', !!cities, 'Cities count:', cities?.length);

    cities?.forEach((item) => {
      console.log('Checking city:', item?.name);
      console.log('City name type:', typeof item?.name);
      console.log(
        'Expected values - lahore:',
        Cities.lahore,
        'faisalabad:',
        Cities.faisalabad,
        'karachi:',
        Cities.karachi,
        'islamabad:',
        Cities.islamabad
      );

      // Normalize city names for comparison
      const normalizedCityName = item?.name?.trim();
      const is3DCity =
        normalizedCityName === Cities.lahore ||
        normalizedCityName === Cities.faisalabad ||
        normalizedCityName === Cities.karachi ||
        normalizedCityName === Cities.islamabad;

      console.log('Is 3D city:', is3DCity, 'for city:', normalizedCityName);

      if (is3DCity) {
        console.log('Creating 3D marker for:', item?.name);
        try {
          createCityThreeDMarker(item.lng, item.lat, item?.alarmsCount, item?.name);
          threeDMarkersRef.current.push({
            lng: item.lng,
            lat: item.lat,
            name: item.name,
          });
        } catch (error) {
          console.error('Error creating 3D marker for', item?.name, ':', error);
        }
      } else {
        console.log('City not in 3D list:', item?.name);
      }
    });
    setThreeDMarkersVisible(true);
    console.log('3D markers created and visible. Total markers:', threeDMarkersRef.current.length);
  };

  // Function to hide 3D markers
  const hideThreeDMarkers = () => {
    // if (!threeDMarkersVisible) {
    //   console.log('3D markers already hidden, skipping');
    //   return; // Already hidden
    // }

    console.log('Removing 3D markers');
    threeDMarkersRef.current.forEach((marker) => {
      removeThreeDLayer(marker.lng, marker.lat);
    });
    threeDMarkersRef.current = [];
    setThreeDMarkersVisible(false);
    console.log('3D markers removed and hidden');
  };

  // Function to handle zoom changes and manage 3D markers
  const handleZoomChange = () => {
    if (!map.current) {
      console.log('Map instance not available for zoom change');
      return;
    }

    const currentZoom = map.current.getZoom();
    console.log(
      'Zoom changed to:',
      currentZoom,
      '3D markers visible:',
      threeDMarkersVisible,
      'City markers visible:',
      cityMarkersVisible
    );
    console.log('Zoom threshold:', ZOOM_THRESHOLD_FOR_3D, 'Upper limit: 9');
    console.log('City markers range:', CITY_MARKERS_ZOOM_MIN, '-', CITY_MARKERS_ZOOM_MAX);

    // Handle 3D markers (zoom 7-8)
    if (currentZoom >= ZOOM_THRESHOLD_FOR_3D && currentZoom < 9 && !threeDMarkersVisible) {
      console.log('Condition met: Showing 3D markers - zoom in range 7-8');
      showThreeDMarkers();
    } else if (currentZoom < 7 || currentZoom >= 9) {
      console.log('Condition met: Hiding 3D markers - zoom outside range 7-8');
      hideThreeDMarkers();
    }

    // Handle city markers (zoom 9-11)
    if (
      currentZoom >= CITY_MARKERS_ZOOM_MIN &&
      currentZoom <= CITY_MARKERS_ZOOM_MAX &&
      !cityMarkersVisible
    ) {
      console.log('Condition met: Showing city markers - zoom in range 9-11');
      showCityMarkers();
    } else if (currentZoom < CITY_MARKERS_ZOOM_MIN || currentZoom > CITY_MARKERS_ZOOM_MAX) {
      console.log('Condition met: Hiding city markers - zoom outside range 9-11');
      hideCityMarkers();
    }
  };

  // Manual test function - call this from console to test 3D markers
  const testThreeDMarkers = () => {
    console.log('Manual test: Creating 3D markers');
    showThreeDMarkers();
  };

  // Manual test function for city markers
  const testCityMarkers = () => {
    console.log('Manual test: Creating city markers');
    showCityMarkers();
  };

  // Expose test function to window for console access
  useEffect(() => {
    window.testThreeDMarkers = testThreeDMarkers;
    window.testCityMarkers = testCityMarkers;
    window.getMapState = () => ({
      currentTab: tab,
      sessionTab: sessionStorage.getItem('selectedTab'),
      activeRequests: requestManagerRef.current ? Array.from(requestManagerRef.current.keys()) : [],
      requestCount: requestManagerRef.current ? requestManagerRef.current.size : 0,
    });
    window.cancelAllMapRequests = cancelAllRequests;

    return () => {
      delete window.testThreeDMarkers;
      delete window.testCityMarkers;
      delete window.getMapState;
      delete window.cancelAllMapRequests;
    };
  }, [tab]);

  // Cleanup effect for zoom event listener, 3D markers, and request cancellation
  useEffect(() => {
    return () => {
      if (map.current) {
        map.current.off('zoom', handleZoomChange);
      }
      hideThreeDMarkers();
      hideCityMarkers();

      // Cancel all ongoing requests when component unmounts
      cancelAllRequests();
    };
  }, []);

  // Effect to handle tab changes and cancel ongoing requests
  useEffect(() => {
    console.log(`[Map] Tab changed to: ${tab}`);

    // Cancel all ongoing requests when tab changes
    cancelAllRequests();

    // Create a new controller for the new tab
    controllerRef.current = new AbortController();

    console.log(`[Map] All requests cancelled for tab change to: ${tab}`);
  }, [tab]);

  // Function to show city markers
  const showCityMarkers = () => {
    if (cityMarkersVisible) {
      console.log('City markers already visible, skipping');
      return; // Already visible
    }

    console.log('Creating city markers');
    cities?.forEach((item) => {
      const cityMarker = new mapboxgl.Marker({
        element: createCityMarkerElement(getImageUrl(item?.name), item?.name, item?.alarmsCount),
      })
        .setLngLat([item.lng, item.lat])
        .addTo(map.current);
      cityMarkers.current.push(cityMarker);
      cityMarker.getElement().addEventListener('click', () => {
        setLng(item.lng);
        setLat(item.lat);
        map.current.flyTo({
          center: [item.lng, item.lat],
          zoom: 12,
          essential: true,
          duration: 2000,
        });
      });
    });
    setCityMarkersVisible(true);
    console.log('City markers created and visible');
  };

  // Function to hide city markers
  const hideCityMarkers = () => {
    console.log('Removing city markers');
    cityMarkers.current.forEach((marker) => marker.remove());
    cityMarkers.current = [];
    setCityMarkersVisible(false);
    console.log('City markers removed and hidden');
  };

  return (
    <div style={{ position: 'relative' }}>
      {isLoading ? (
        // Render loading state
        <Box>
          <Skeleton variant="rectangular" sx={{ height: 'calc(100vh - 72px)' }} />
        </Box>
      ) : (
        // Render map and header
        <>
          {renderHeader}
          <div ref={mapContainer} style={{ height: 'calc(100vh - 72px)' }}>
            <div className="mapboxgl-ctrl-logo" style={{ display: 'none' }}></div>
          </div>
          {renderFooter}
        </>
      )}
    </div>
  );
}
